import parseCookie from '@utils/parseCookie'

export const Config = {
  HEADERS: {
    'Content-Type': 'application/json; charset=utf-8',
    // Authorization: `Bearer ${parseCookie(document.cookie).auth}`,
  },
  MULTIPART_HEADERS: { 'Content-Type': 'multipart/form-data; charset= utf-8; boundary=---sad' },
}

export const PRES_URL = '/api/presentations'
export const ONITY_URL = '/api/onity'
export const GIGAPRES_URL = '/api/gigapresentations'
export const PREVIEWS_URL = '/api/previews'
export const USERS_URL = '/api/users'
export const AUTH_URL = '/api/auth'
export const SLIDE_URL = '/slides'

export const README =
  'https://docs.google.com/presentation/d/1FTcT01WMZm2iAWmaiUnj2BOamNcvvMH7SHC9IwfRmYE/edit#slide=id.g3523d206db7_0_0'
